import { Preferences } from '@capacitor/preferences'
import { isNil } from 'ramda'

import type { AtomEffect } from 'recoil'

const capacitorPreferencesEffect =
  <T>(key: string, defaultValue?: unknown): AtomEffect<T> =>
  ({ setSelf, onSet, trigger }) => {
    // If there's a persisted value - set it on load
    const loadPersisted = async () => {
      const cachedValue = await Preferences.get({ key })

      try {
        setSelf(isNil(cachedValue?.value) ? (defaultValue ?? undefined) : JSON.parse(cachedValue.value))
      } catch {
        setSelf(undefined as unknown as T)
      }
    }

    // Asynchronously set the persisted data
    if (trigger === 'get') {
      loadPersisted()
    }

    // Subscribe to state changes and persist them to localForage
    onSet((newValue, _, isReset: boolean) => {
      if (isReset) {
        Preferences.remove({ key })
      } else {
        Preferences.set({ key, value: JSON.stringify(newValue) })
      }
    })
  }

export { capacitorPreferencesEffect }
